/**
 * SEMILLA del equipo (canon F6, equipo.html): las 4 personas del Skein
 * Team, su rol y su actividad de hoy — el directorio real (altas, roles,
 * retiradas) llega con F5b, igual que los «actos hoy» (hoy narrados a
 * mano bajo la tabla; la auditoría real los sustituirá). El acceso a
 * cada mando de admin queda deshabilitado tal como lo fija el prototipo
 * (visibilidad ≠ autorización) — no hay un segundo estado «viewer admin»
 * diseñado, así que no se inventa uno.
 */
export type RolEquipo = "admin" | "curadora" | "curador";
export interface PersonaSeed {
  nombre: string;
  email: string;
  rol: RolEquipo;
  ultimoAcceso: string;
  actosHoy: number | null; // null → «—» (los admins no curan)
}
export const PERSONAS: readonly PersonaSeed[] = [
  { nombre: "Martí Gascó", email: "marti@weareskein.ai", rol: "admin", ultimoAcceso: "ayer 19:40", actosHoy: null },
  { nombre: "Enric Segura", email: "enric.segura@weareskein.ai", rol: "admin", ultimoAcceso: "3 ago", actosHoy: null },
  { nombre: "Núria Serra", email: "nuria@weareskein.ai", rol: "curadora", ultimoAcceso: "ahora", actosHoy: 3 },
  { nombre: "Eloi Puig", email: "eloi@weareskein.ai", rol: "curador", ultimoAcceso: "hoy 10:15", actosHoy: 1 },
] as const;
